import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(VSubheader, [
        _vm._v(
          " " +
            _vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.entryAdjTitle")) +
            " (" +
            _vm._s(_vm.$vuetify.lang.t("$vuetify.base.weight")) +
            ": " +
            _vm._s(_vm._f("formatNumber")(_vm.worksheetEntry.netWeight)) +
            " " +
            _vm._s(_vm.productInfo ? _vm.productInfo.measureWeight : "") +
            ") "
        ),
      ]),
      _c(
        "div",
        [
          _c(VTextField, {
            staticClass: "ma-4",
            attrs: {
              type: "number",
              outlined: "",
              "hide-details": "",
              dense: "",
              suffix: _vm.productInfo ? _vm.productInfo.measureWeight : "",
              label: _vm.$vuetify.lang.t("$vuetify.base.adjustmentWeight"),
            },
            model: {
              value: _vm.adjustment.quantity,
              callback: function ($$v) {
                _vm.$set(_vm.adjustment, "quantity", _vm._n($$v))
              },
              expression: "adjustment.quantity",
            },
          }),
          _c("div", { staticClass: "ml-5 text-caption" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$vuetify.lang.t("$vuetify.base.netWeight")) +
                ": " +
                _vm._s(
                  _vm._f("formatNumber")(
                    _vm.worksheetEntry.netWeight +
                      (_vm.adjustment.quantity ? _vm.adjustment.quantity : 0)
                  )
                ) +
                " " +
                _vm._s(_vm.productInfo ? _vm.productInfo.measureWeight : "")
            ),
          ]),
          _c(VTextarea, {
            staticClass: "ma-4",
            attrs: {
              rows: "2",
              label: _vm.$vuetify.lang.t("$vuetify.base.notes"),
              outlined: "",
            },
            model: {
              value: _vm.adjustment.notes,
              callback: function ($$v) {
                _vm.$set(_vm.adjustment, "notes", $$v)
              },
              expression: "adjustment.notes",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-space-around" },
        [
          _c(
            VBtn,
            { attrs: { color: "primary" }, on: { click: _vm.addAdjstment } },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.add")))]
          ),
          _c(
            VBtn,
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.cancel")))]
          ),
        ],
        1
      ),
      _vm.adjustments && _vm.adjustments.length > 0
        ? _c(
            "div",
            [
              _c(VDivider),
              _c(VSubheader, [
                _vm._v(
                  _vm._s(
                    _vm.$vuetify.lang.t("$vuetify.worksheet.adjustmentHistory")
                  )
                ),
              ]),
              _c(VSimpleTable, { staticClass: "mb-6" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th"),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$vuetify.lang.t("$vuetify.base.weight"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$vuetify.lang.t("$vuetify.base.notes"))
                      ),
                    ]),
                    _c("th"),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.adjustments, function (adj, index) {
                    return _c("tr", { key: adj.id }, [
                      _c("td", [_vm._v(_vm._s(index + 1))]),
                      _c("td", [
                        _vm._v(
                          " " +
                            _vm._s(adj.quantity > 0 ? "+" : "") +
                            _vm._s(_vm._f("formatNumber")(adj.quantity)) +
                            " " +
                            _vm._s(
                              _vm.productInfo
                                ? _vm.productInfo.measureWeight
                                : ""
                            ) +
                            " "
                        ),
                      ]),
                      _c("td", [_vm._v(_vm._s(adj.notes))]),
                      _c(
                        "td",
                        [
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteAdjstment(adj)
                                },
                              },
                            },
                            [_c(VIcon, [_vm._v("mdi-delete-outline")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }